import React, { Component } from 'react';

import { moves } from 'data/moves';

import poketypes from 'utils/poketypes';

import TypeBadge from 'components/TypeBadge';

class PokemonMoveCard extends Component {
  render() {
    const move = moves.find((move) => {
      return move.name === this.props.move;
    });

    return (
      <article className="PokemonMoveCard p:s  bgc:white c:dark-pewter">
        <div className="d:f fld:r ac:sb">
          <header className="flg:1">
            <h1 className="ts:small fw:5">{move.name}</h1>

            {(move.energyCost > 0) && (
              <div className="d:f h:0 p-r:m" style={{marginTop:'8px', maxWidth:'14rem'}}>
                <div className={'EnergyCost EnergyCost:'+move.energyCost}></div>
              </div>
            )}
          </header>

          <div>
            <span className="ts:tiny c:pewter">DPS</span> <span className="ts:small">
              {(this.props.userTypes && this.props.userTypes.includes(move.type)) ? <span className="fw:6" style={{color: poketypes[move.type].color}}>{(move.dps * 1.25).toFixed(2)}</span> : move.dps.toFixed(2)}
            </span>
          </div>
        </div>

        <div className="g:12 jc:sb  m-t:xs  ts:tiny">
          <div className={'gcol:'+ (move.eps ? '3' : '4')}>
            <span className="ts:tiny c:pewter">CD </span>
            {move.cooldown}
          </div>
          <div className={'gcol:'+ (move.eps ? '3' : '4')}>
            <span className="ts:tiny c:pewter">PWR </span>
            {move.power}
          </div>
          {move.eps > 0 && (
            <div className={'gcol:'+ (move.eps ? '3' : '4')}>
              <span className="ts:tiny c:pewter">EPS </span>
              {move.eps}
            </div>
          )}

          <div className={'gcol:'+ (move.eps ? '3' : '3 as:fe')}>
            <div className="m-l:a" style={{maxWidth:'80px'}}>
              <TypeBadge type={move.type} key={move.type} />
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default PokemonMoveCard;



// WEBPACK FOOTER //
// ./src/components/PokemonMoveCard.js